import EmploymentDetailsScreen from './EmploymentDetailsScreen';

export default EmploymentDetailsScreen;
